/**
 * useFinalExerciseDraft
 * Persiste el borrador del ejercicio final en localStorage.
 * Clave: epl_exercise_draft_{programSlug}
 */
import { useState, useCallback } from 'react';

const EMPTY_DRAFT = { q1: '', q2: '', q3: '', submitted: false, feedbackShown: false, claimResult: null };

function getKey(programSlug) {
  return `epl_exercise_draft_${programSlug}`;
}

export function useFinalExerciseDraft(programSlug) {
  const [draft, setDraftState] = useState(() => {
    try {
      const raw = localStorage.getItem(getKey(programSlug));
      return raw ? JSON.parse(raw) : EMPTY_DRAFT;
    } catch {
      return EMPTY_DRAFT;
    }
  });

  const updateDraft = useCallback((updates) => {
    setDraftState(prev => {
      const next = { ...prev, ...updates };
      try {
        localStorage.setItem(getKey(programSlug), JSON.stringify(next));
      } catch {/* silenced */}
      return next;
    });
  }, [programSlug]);

  const clearDraft = useCallback(() => {
    localStorage.removeItem(getKey(programSlug));
    setDraftState(EMPTY_DRAFT);
  }, [programSlug]);

  return { draft, updateDraft, clearDraft };
}
